module.exports = __webpack_public_path__ + "img/store-walmart.4a572d8d.svg";